/* tslint:disable */
/* eslint-disable */
/**
 * Donio
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AccessDeniedExceptionResponse,
  ApiRequestValidationExceptionResponse,
  BadRequestExceptionResponse,
  CreateDonationRequest,
  CreateDonationResponse,
  DonationDetailResponse,
  DonationsListResponse,
  InternalServerErrorExceptionResponse,
  NotFoundExceptionResponse,
  PaymentInfoResponse,
  SetCommentRequest,
  SetCommentResponse,
} from '../models/index';
import {
    AccessDeniedExceptionResponseFromJSON,
    AccessDeniedExceptionResponseToJSON,
    ApiRequestValidationExceptionResponseFromJSON,
    ApiRequestValidationExceptionResponseToJSON,
    BadRequestExceptionResponseFromJSON,
    BadRequestExceptionResponseToJSON,
    CreateDonationRequestFromJSON,
    CreateDonationRequestToJSON,
    CreateDonationResponseFromJSON,
    CreateDonationResponseToJSON,
    DonationDetailResponseFromJSON,
    DonationDetailResponseToJSON,
    DonationsListResponseFromJSON,
    DonationsListResponseToJSON,
    InternalServerErrorExceptionResponseFromJSON,
    InternalServerErrorExceptionResponseToJSON,
    NotFoundExceptionResponseFromJSON,
    NotFoundExceptionResponseToJSON,
    PaymentInfoResponseFromJSON,
    PaymentInfoResponseToJSON,
    SetCommentRequestFromJSON,
    SetCommentRequestToJSON,
    SetCommentResponseFromJSON,
    SetCommentResponseToJSON,
} from '../models/index';

export interface GetDonationByIdRequest {
    id: string;
}

export interface GetDonationByPublicIdRequest {
    publicId: string;
}

export interface GetDonationPaymentInfoRequest {
    publicId: string;
}

export interface GetDonationPaymentWireTransferQrRequest {
    publicId: string;
}

export interface GetDonationsRequest {
    project?: string | null;
    subproject?: string | null;
    user?: string | null;
    statuses?: Array<GetDonationsStatusesEnum>;
    withVisibleComment?: GetDonationsWithVisibleCommentEnum;
    sort?: GetDonationsSortEnum;
    limit?: number;
    offset?: number;
}

export interface PostCreateDonationRequest {
    dryRun?: PostCreateDonationDryRunEnum;
    createDonationRequest?: CreateDonationRequest;
}

export interface SetDonationCommentRequest {
    publicId: string;
    setCommentRequest?: SetCommentRequest;
}

/**
 * 
 */
export class DonationsApi extends runtime.BaseAPI {

    /**
     */
    async getDonationByIdRaw(requestParameters: GetDonationByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DonationDetailResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getDonationById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/donations/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DonationDetailResponseFromJSON(jsonValue));
    }

    /**
     */
    async getDonationById(requestParameters: GetDonationByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DonationDetailResponse> {
        const response = await this.getDonationByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getDonationByPublicIdRaw(requestParameters: GetDonationByPublicIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DonationDetailResponse>> {
        if (requestParameters['publicId'] == null) {
            throw new runtime.RequiredError(
                'publicId',
                'Required parameter "publicId" was null or undefined when calling getDonationByPublicId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/donations/public-id/{publicId}`.replace(`{${"publicId"}}`, encodeURIComponent(String(requestParameters['publicId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DonationDetailResponseFromJSON(jsonValue));
    }

    /**
     */
    async getDonationByPublicId(requestParameters: GetDonationByPublicIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DonationDetailResponse> {
        const response = await this.getDonationByPublicIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getDonationPaymentInfoRaw(requestParameters: GetDonationPaymentInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaymentInfoResponse>> {
        if (requestParameters['publicId'] == null) {
            throw new runtime.RequiredError(
                'publicId',
                'Required parameter "publicId" was null or undefined when calling getDonationPaymentInfo().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/donations/public-id/{publicId}/payment-info`.replace(`{${"publicId"}}`, encodeURIComponent(String(requestParameters['publicId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaymentInfoResponseFromJSON(jsonValue));
    }

    /**
     */
    async getDonationPaymentInfo(requestParameters: GetDonationPaymentInfoRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaymentInfoResponse> {
        const response = await this.getDonationPaymentInfoRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns wire transfer payment QR code. Only works for `wire-transfer` payment type, obviously.
     */
    async getDonationPaymentWireTransferQrRaw(requestParameters: GetDonationPaymentWireTransferQrRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters['publicId'] == null) {
            throw new runtime.RequiredError(
                'publicId',
                'Required parameter "publicId" was null or undefined when calling getDonationPaymentWireTransferQr().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/donations/public-id/{publicId}/payment-info/wire-transfer-qr`.replace(`{${"publicId"}}`, encodeURIComponent(String(requestParameters['publicId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * Returns wire transfer payment QR code. Only works for `wire-transfer` payment type, obviously.
     */
    async getDonationPaymentWireTransferQr(requestParameters: GetDonationPaymentWireTransferQrRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.getDonationPaymentWireTransferQrRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Either `project`, `subproject` or `user` must be supplied
     */
    async getDonationsRaw(requestParameters: GetDonationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DonationsListResponse>> {
        const queryParameters: any = {};

        if (requestParameters['project'] != null) {
            queryParameters['project'] = requestParameters['project'];
        }

        if (requestParameters['subproject'] != null) {
            queryParameters['subproject'] = requestParameters['subproject'];
        }

        if (requestParameters['user'] != null) {
            queryParameters['user'] = requestParameters['user'];
        }

        if (requestParameters['statuses'] != null) {
            queryParameters['statuses'] = requestParameters['statuses'];
        }

        if (requestParameters['withVisibleComment'] != null) {
            queryParameters['withVisibleComment'] = requestParameters['withVisibleComment'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/donations`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DonationsListResponseFromJSON(jsonValue));
    }

    /**
     * Either `project`, `subproject` or `user` must be supplied
     */
    async getDonations(requestParameters: GetDonationsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DonationsListResponse> {
        const response = await this.getDonationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create new donation (submit checkout form)
     */
    async postCreateDonationRaw(requestParameters: PostCreateDonationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateDonationResponse>> {
        const queryParameters: any = {};

        if (requestParameters['dryRun'] != null) {
            queryParameters['dryRun'] = requestParameters['dryRun'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/donations`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateDonationRequestToJSON(requestParameters['createDonationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateDonationResponseFromJSON(jsonValue));
    }

    /**
     * Create new donation (submit checkout form)
     */
    async postCreateDonation(requestParameters: PostCreateDonationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateDonationResponse | null | undefined > {
        const response = await this.postCreateDonationRaw(requestParameters, initOverrides);
        switch (response.raw.status) {
            case 200:
                return await response.value();
            case 204:
                return null;
            default:
                return await response.value();
        }
    }

    /**
     * Set (add, edit, hide, remove) comment for a donation
     */
    async setDonationCommentRaw(requestParameters: SetDonationCommentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SetCommentResponse>> {
        if (requestParameters['publicId'] == null) {
            throw new runtime.RequiredError(
                'publicId',
                'Required parameter "publicId" was null or undefined when calling setDonationComment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/donations/public-id/{publicId}/comment`.replace(`{${"publicId"}}`, encodeURIComponent(String(requestParameters['publicId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SetCommentRequestToJSON(requestParameters['setCommentRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SetCommentResponseFromJSON(jsonValue));
    }

    /**
     * Set (add, edit, hide, remove) comment for a donation
     */
    async setDonationComment(requestParameters: SetDonationCommentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SetCommentResponse> {
        const response = await this.setDonationCommentRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const GetDonationsStatusesEnum = {
    New: 'new',
    Paid: 'paid',
    Cancelled: 'cancelled',
    Refunded: 'refunded',
    RefundedWithoutTip: 'refunded-without-tip'
} as const;
export type GetDonationsStatusesEnum = typeof GetDonationsStatusesEnum[keyof typeof GetDonationsStatusesEnum];
/**
 * @export
 */
export const GetDonationsWithVisibleCommentEnum = {
    NUMBER_0: 0,
    NUMBER_1: 1
} as const;
export type GetDonationsWithVisibleCommentEnum = typeof GetDonationsWithVisibleCommentEnum[keyof typeof GetDonationsWithVisibleCommentEnum];
/**
 * @export
 */
export const GetDonationsSortEnum = {
    AmountAsc: 'amount:ASC',
    AmountDesc: 'amount:DESC',
    CreatedAtAsc: 'createdAt:ASC',
    CreatedAtDesc: 'createdAt:DESC'
} as const;
export type GetDonationsSortEnum = typeof GetDonationsSortEnum[keyof typeof GetDonationsSortEnum];
/**
 * @export
 */
export const PostCreateDonationDryRunEnum = {
    NUMBER_0: 0,
    NUMBER_1: 1
} as const;
export type PostCreateDonationDryRunEnum = typeof PostCreateDonationDryRunEnum[keyof typeof PostCreateDonationDryRunEnum];
